<template>
  <pricing-and-collections-settings />
</template>

<script>
import PricingAndCollectionsSettings from "@/components/3pl/Settings/PricingAndCollections/index";
export default {
  components: {
    PricingAndCollectionsSettings,
  },
};
</script>

<style></style>